/*
 * @Author: your name
 * @Date: 2021-09-26 21:29:54
 * @LastEditTime: 2024-07-22 11:32:13
 * @LastEditors: lbb lhz6887@163.com
 * @Description: In User Settings Edit
 * @FilePath: \h5-vip\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 路由懒加载
// component: () => import ('文件路径')

let data = window.location.href != 'https://h5-hls.yhbyf.com/' ? {
	path: "/",
	name: "registered",
	meta: {
		title: "加入易伙伴"
	},
	component: () =>
		import('@/pages/registered')
} : {
	path: "/",
	name: "hlsDownload",
	meta: {
		title: "下载吉祥刷App"
	},
	component: () =>
		import('../pages/download/hlsDownload')
}

const router = new Router({
	mode: 'history', //去掉#号
	routes: [
		data, {
			path: "/download",
			name: "download",
			meta: {
				title: "下载易伙伴App"
			},
			component: () =>
				import('../pages/download/index')
		}, {
			path: "/sysdownload",
			name: "sysdownload",
			meta: {
				title: "下载如意刷App"
			},
			component: () =>
				import('../pages/download/sysdownload')
		}, {
			path: "/jsbdownload",
			name: "jsbdownload",
			meta: {
				title: "下载聚收宝App"
			},
			component: () =>
				import('../pages/download/jsbdownload')
		}, {
			path: "/jsbAdminDownload",
			name: "jsbAdminDownload",
			meta: {
				title: "下载中心"
			},
			component: () =>
				import('../pages/download/jsbAdminDownload')
		}, {
			path: "/jxsdownload",
			name: "jxsdownload",
			meta: {
				title: "下载吉祥刷App"
			},
			component: () =>
				import('../pages/download/jxsdownload')
		}, {
			path: "/jxsposdownload",
			name: "jxsposdownload",
			meta: {
				title: "下载吉祥刷大POS"
			},
			component: () =>
				import('../pages/download/jxsposdownload')
		}, {
			path: "/xfsDownload",
			name: "xfsDownload",
			meta: {
				title: "下载幸福刷App"
			},
			component: () =>
				import('../pages/download/xfsDownload')
		}, {
			path: "/hlsDownload",
			name: "hlsDownload",
			meta: {
				title: "下载吉祥刷App"
			},
			component: () =>
				import('../pages/download/hlsDownload')
		}, {
			path: "/service",
			name: "service",
			meta: {
				title: ""
			},
			component: () =>
				import('../pages/chatgpt/serviceAi')
		}, {
			path: "/agreement",
			name: "agreement",
			meta: {
				title: "隐私政策"
			},
			component: () =>
				import('@/pages/agreement')
		}, {
			path: "/userInformation",
			name: "userInformation",
			meta: {
				title: "信息核验"
			},
			component: () =>
				import('@/pages/userInformation')
		}, {
			path: "/authorization",
			name: "authorization",
			meta: {
				title: "信用卡申请"
			},
			component: () =>
				import('@/pages/authorization')
		}, {
			path: "/creditCard",
			name: "creditCard",
			meta: {
				title: "信用卡申请"
			},
			component: () =>
				import('@/pages/creditCard/index.vue')
		},
    {
			path: "/loans",
			name: "loans",
			meta: {
				title: "信贷申请"
			},
			component: () =>
				import('@/pages/loans/index.vue')
		},
		{
			path: "/activityResoure",
			name: "activityResoure",
			meta: {
				title: "信用卡申请"
			},
			component: () =>
				import('@/pages/activityResoure')
		},

		{
			path: "/activityDetail",
			name: "activityDetail",
			meta: {
				title: "活动详情"
			},
			component: () =>
				import('@/pages/activityDetail')
		}, {
			path: "/activity",
			name: "activity",
			meta: {
				title: "活动列表"
			},
			component: () =>
				import('@/pages/activity')
		},
		{
			path: "/extension",
			name: "extension",
			meta: {
				title: "资源详情"
			},
			component: () =>
				import('@/pages/extension')
		},
		{
			path: "/cardapplication",
			name: "cardapplication",
			meta: {
				title: "申卡订单"
			},
			component: () =>
				import('@/pages/cardapplication')
		},
    {
			path: "/loansList",
			name: "loansList",
			meta: {
				title: "申贷订单"
			},
			component: () =>
				import('@/pages/cardapplication/newIndex')
		},
		{
			path: "/khAuthorizationAgreement",
			name: "khAuthorizationAgreement",
			meta: {
				title: "用户授权册协议"
			},
			component: () =>
				import('@/pages/agreement/khAuthorizationAgreement')
		}, {
			path: "/khRegistrationAgreement",
			name: "khRegistrationAgreement",
			meta: {
				title: "易伙伴用户注册服务协议"
			},
			component: () =>
				import('@/pages/agreement/khRegistrationAgreement')
		}, {
			path: "/qr",
			name: "qr",
			meta: {
				title: "扫码办卡"
			},
			component: () =>
				import('@/pages/qr/index')
		}, {
			path: "/articledetails",
			name: "articledetails",
			meta: {
				title: "文章详情"
			},
			component: () =>
				import('@/pages/articledetails/articledetails')
		}, {
			path: "/privacyPolicy",
			name: "privacyPolicy",
			meta: {
				title: "隐私政策"
			},
			component: () =>
				import('@/pages/rys/privacyPolicy')
		},
		{
			path: "/jxsWill",
			name: "jxsWill",
			meta: {
				title: ""
			},
			component: () =>
				import('@/pages/HumanFace/jxsWill')
		}, {
			path: "/yhbHumanFace",
			name: "yhbHumanFace",
			meta: {
				title: "提交成功"
			},
			component: () =>
				import('@/pages/HumanFace/yhbHumanFace')
		}, {
			//聚收宝隐私政策
			path: "/jsbprivacyPolicy",
			name: "jsbprivacyPolicy",
			meta: {
				title: "隐私政策"
			},
			component: () =>
				import('@/pages/jsb/privacyPolicy')
		},
		// 聚惠团隐私政策
		{
			path: "/jhtPrivacyPolicy",
			name: "jhtPrivacyPolicy",
			meta: {
				title: "隐私政策"
			},
			component: () =>
				import('@/pages/jht/privacyPolicy')
		}, {
			path: "/jsbkhRegistrationAgreement",
			name: "khRegistrationAgreement",
			meta: {
				title: "聚收宝用户注册服务协议"
			},
			component: () =>
				import('@/pages/jsb/khRegistrationAgreement')
		}, {
			path: "/jsbxzb",
			name: "xzb",
			meta: {
				title: ""
			},
			component: () =>
				import('@/pages/jsb/xzb')
		}, {
			path: "/HumanFace",
			name: "HumanFace",
			meta: {
				title: "信息采集"
			},
			component: () =>
				import('@/pages/HumanFace/HumanFace')
		}, {
			path: "/willingness",
			name: "willingness",
			meta: {
				title: "意愿核身"
			},
			component: () =>
				import('@/pages/HumanFace/willingness')
		}, {
			path: "/will",
			name: "will",
			meta: {
				title: "意愿核身"
			},
			component: () =>
				import('@/pages/HumanFace/will')
		}, {
			path: "/kxswill",
			name: "kxswill",
			meta: {
				title: "意愿核身"
			},
			component: () =>
				import('@/pages/HumanFace/kxswill')
		},
		// 一键注册 注册页面
		{
			path: "/oneClickRegister",
			name: "oneClickRegister",
			meta: {
				title: "一键注册"
			},
			component: () =>
				import('@/pages/oneClickRegister/index')
		},
		{
			path: "/registerMerchant",
			name: "registerMerchant",
			meta: {
				title: "商户进件"
			},
			component: () =>
				import('@/pages/oneClickRegister/registerMerchant')
		},
		// 一键注册 协议页面
		{
			path: "/privacypolicy",
			name: "privacypolicy",
			meta: {
				title: ""
			},
			component: () =>
				import('@/pages/agreement/privacypolicy')
		},
		{ // 一键注册完成页面
			path: "/registerComplete",
			name: "registerComplete",
			meta: {
				title: ""
			},
			component: () =>
				import('@/pages/oneClickRegister/complete')
		},
		{ // 所有隐私协议
			path: "/defaultAgreement",
			name: "defaultAgreement",
			meta: {
				title: ""
			},
			component: () =>
				import('@/pages/defaultAgreement/index')
		},
		{ // 所有隐私协议
			path: "/yhbWithdrawFace",
			name: "yhbWithdrawFace",
			meta: {
				title: "人脸识别"
			},
			component: () =>
				import('@/pages/HumanFace/yhbWithdrawFace')
		},
	]
})
let arr = [{
		path: "/rysUserAgreement",
		name: "rysUserAgreement",
		meta: {
			title: "如意刷用户注册服务协议"
		},
		component: () =>
			import('@/pages/policy-privacy/rysUserAgreement')
	},
	{
		path: "/jxsUserAgreement",
		name: "jxsUserAgreement",
		meta: {
			title: "吉祥刷用户注册服务协议"
		},
		component: () =>
			import('@/pages/policy-privacy/jxsUserAgreement')
	},
	{
		path: "/kxsUserAgreement",
		name: "kxsUserAgreement",
		meta: {
			title: "开心刷用户注册服务协议"
		},
		component: () =>
			import('@/pages/policy-privacy/kxsUserAgreement')
	},
	{
		path: "/xfsUserAgreement",
		name: "xfsUserAgreement",
		meta: {
			title: "幸福刷用户注册服务协议"
		},
		component: () =>
			import('@/pages/policy-privacy/xfsUserAgreement')
	},
	{
		path: "/kxsPrivacyPolicy",
		name: "kxsPrivacyPolicy",
		meta: {
			title: "开心刷隐私政策"
		},
		component: () =>
			import('@/pages/policy-privacy/kxsPrivacyPolicy')
	},
	{
		path: "/jxsPrivacyPolicy",
		name: "jxsPrivacyPolicy",
		meta: {
			title: "吉祥刷隐私政策"
		},
		component: () =>
			import('@/pages/policy-privacy/jxsPrivacyPolicy')
	},
	{
		path: "/xfsPrivacyPolicy",
		name: "xfsPrivacyPolicy",
		meta: {
			title: "幸福刷隐私政策"
		},
		component: () =>
			import('@/pages/policy-privacy/xfsPrivacyPolicy')
	},
	{
		path: "/xfsMachineAgreement",
		name: "xfsMachineAgreement",
		meta: {
			title: "机具使用协议"
		},
		component: () =>
			import('@/pages/policy-privacy/xfsMachine')
	},
]
router.addRoutes(arr)

router.beforeEach((to, from, next) => { //beforeEach是router的钩子函数，在进入路由前执行
	if (to.meta.title) { //判断是否有标题
		document.title = to.meta.title
	}
	const app = router.app;
	if (app) {
		app.$root.isLoading = true;
	}
	next();
})
export default router